var supportPseudo = function () {
    var ss = document.styleSheets[0];
    if (!ss) {
        var el = document.createElement('style');
        document.head.appendChild(el);
        ss = document.styleSheets[0];
        document.head.removeChild(el);
    }
    return function (pseudoClass) {
        try {
            if (!(/^:/).test(pseudoClass)) {
                pseudoClass = ':' + pseudoClass;
            }
            ss.insertRule('html' + pseudoClass + '{}', 0);
            ss.deleteRule(0);
            return true;
        } catch (e) {
            return false;
        }
    };
}();

(function ($) {
    var $win = $(window);
    var $doc = $(document);
    var $body = $('body');
    var hash = window.location.hash.substr(1);
    /* ------------------------------ /
     * Font Loader setup.
     * ------------------------------ */
    WebFont.load({
        custom: {
            families: ['open_sans'],
            urls: [site.theme_uri + '/assets/css/fonts.min.css']
        }
    });

    /* ------------------------------ /
     * Polyfill Setup
     * ------------------------------ */
    if (supportPseudo(':focus-within')) {
        $body.addClass('supports--focus-within');
    }

    $doc.on('blur', '.hbspt-form input, .hbspt-form textarea, .hbspt-form select', function () {
        var $this = $(this);
        var $thisField = $this.closest('.field');
        if ($this.val()) {
            $thisField.addClass('filled');
        }
        else {
            $thisField.removeClass('filled');
        }
    });
    objectFitImages();

    /* ------------------------------ /
     * Main menu setup.
     * ------------------------------ */
    $('.navbar.site-navigation .menu-item-has-children').append('<span class="dropdown-menu-toggle"></span>');
    $('.dropdown-menu-toggle').click(function () {
        $(this).parent().toggleClass('open');
    });
    $('.menu-button').click(function () {
        $(this).toggleClass('active');
    });
    $('.full-menu-panel .close').click(function () {
        $('.menu-button').removeClass('active');
    });
    $('.full-menu-panel .menu-item-has-children').each(function () {
        var $thisItem = $(this);
        var $thisLink = $thisItem.find('> a');
        var $thisSub = $thisItem.find('> .sub-menu');
        var $thisItemParent = $thisItem.parent();
        var $thisMenu = $thisItem.closest('.primary-menu');

        // Clone the link into the sub menu if it has a valid url
        if ($thisLink.attr('href') !== undefined && $thisLink.attr('href') !== '' && $thisLink.attr('href') !== '#') {
            var $linkClone = $thisLink.clone();
            var linkwrapper = '<li class="' + $thisItem.attr('class') + '"></li>';
            $linkClone.prependTo($thisSub);
            $linkClone.wrap(linkwrapper);
            $linkClone.parent().removeClass('menu-item-has-children');
        }

        // Append back button to sub menu
        $thisSub.prepend('<li class="sub-menu-back menu-item">Back</li>');

        // Click events to open and close the sub menu
        $thisLink.click(function (e) {
            e.preventDefault();
            $thisItemParent.find('> .active').removeClass('active');
            $thisItem.addClass('active');
            $thisMenu.addClass('sub-open');
        });

        $thisSub.find('.sub-menu-back').click(function () {
            $thisMenu.removeClass('sub-open');
        });
    });

    /* ------------------------------ /
     * Product icon functions
     * ------------------------------ */
    function MoveIconIndicator($indicator, $target) {
        $indicator.css('left', $target.position().left + 'px').css('width', $target.width() + 'px');
    }

    $('.icons-row').each(function () {
        var $thisRow = $(this);
        var $buttons = $thisRow.find('.icon-button');
        var $indicator = $thisRow.find('.icon-indicator');
        var $contentSection = $thisRow.closest('.section-featured-products');

        var indicatorWidth = (100 / $buttons.length) + '%';
        $indicator.css('width', indicatorWidth);
        $buttons.mouseenter(function () {
            var $thisButton = $(this);
            MoveIconIndicator($indicator, $thisButton);
        });

        $thisRow.mouseleave(function () {
            var $activeButton = $thisRow.find('.icon-button.active');
            MoveIconIndicator($indicator, $activeButton);
        });

        $buttons.click(function () {
            var $thisButton = $(this);
            if (!$thisButton.hasClass('active')) {
                var targetHash = '#' + $thisButton.data('target');
                $thisRow.find('.icon-button.active').removeClass('active');
                $thisButton.addClass('active');
                $contentSection.find('.product-excerpt-row.active').removeClass('active');
                $contentSection.find(targetHash).addClass('active');
            }
        });
    });

    /* ------------------------------ /
     * Project Slider functions
     * ------------------------------ */
    var productSliderProductTemplate = '<div class="col"><a href="{{product_url}}" class="project-example loading"><img src="{{product_image}}"><div class="project-example-title">{{product_title}}</div></a></div>';
    if ($('.project-slider').length) {
        var projectSlider = $('.project-slider').owlCarousel({
            items: 1,
            dots: false,
            nav: true,
            navContainer: '.owl-nav .owl-nav-buttons',
            navText: ['<div class="arrow"></div>', '<div class="arrow"></div>'],
            autoplay: true,
            autoplayHoverPause: true,
            animateOut: 'fadeOut',
            loop: true,
            rewind: true,
            touchDrag: false,
            mouseDrag: false
        });

        projectSlider.on('translated.owl.carousel', function (e) {
            renderProjectTitle();
            renderProjectSliderProdutcts();
        });

        $('.project-example-container, .owl-nav-buttons').hover(function () {
            projectSlider.trigger('stop.owl.autoplay');
        }, function () {
            projectSlider.trigger('play.owl.autoplay');
        });

        $('.project-example-container .toggle-button').click(function () {
            $(this).closest('.project-example-container').toggleClass('active');
            renderProjectSliderProdutcts();
        });

    }

    var projectTitleTimeout = 0;

    function renderProjectTitle() {
        var projectTitle = projectSlider.find('.owl-item.active .slide').attr('title');
        var productTitleWrapper = projectSlider.closest('section').find('.project-title');
        clearTimeout(projectTitleTimeout);
        productTitleWrapper.addClass('loading');
        projectTitleTimeout = setTimeout(function () {
            productTitleWrapper.find('h1').text(projectTitle);
            productTitleWrapper.removeClass('loading');
        }, 250);
    }

    function renderProjectSliderProdutcts() {
        var productData = projectSlider.find('.owl-item.active .slide').data('products');
        var productRow = projectSlider.closest('section').find('.project-example-row');
        if (productRow.parent().hasClass('active')) {
            console.log('changed');
            productRow.find('.col').remove();
            $.each(productData.products, function () {
                var product = Mustache.render(productSliderProductTemplate, this);
                productRow.append(product);
            });
            lazyLoadEvents();
        }
    }

    function lazyLoadEvents() {
        $('.loading img').load(function () {
            $(this).closest('.loading').removeClass('loading');
        });
    }

    lazyLoadEvents();

    /* ------------------------------ /
     * Project Single functions
     * ------------------------------ */
    var $projectCarousel = $('.project-main__carousel');

    $projectCarousel.magnificPopup({
        delegate: 'a',
        type: 'image',
        closeOnContentClick: false,
        closeBtnInside: false,
        mainClass: 'mfp-with-zoom mfp-img-mobile',
        image: {
            verticalFit: true,
        },
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: true,
            duration: 300,
            opener: function (element) {
                return element.find('img');
            }
        }
    });

    $projectCarousel.owlCarousel({
        items: 1,
        dots: true,
        autoplay: true,
        autoplayHoverPause: true,
        loop: true,
        rewind: true,
    });

    $('.project-hero__products .toggle-button, .project-hero__products .close').click(function () {
        $(this).closest('.project-hero__products').toggleClass('active');
    });

    /* ------------------------------ /
     * Product Single functions
     * ------------------------------ */
    $('.related-projects__carousel').owlCarousel({
        items: 1,
        dots: true,
        autoplay: true,
        autoplayHoverPause: true,
        loop: false,
        rewind: true,
        margin: 30,
        responsive: {
            576: {
                items: 2
            },
            992: {
                items: 3
            }
        }
    });

    /* ------------------------------ /
     * Fancy Fields functions
     * ------------------------------ */
    var iconSvgWrapper = '<div class="icon"><svg><use xlink:href="{{hash}}" width="100%" height="100%"></use></svg></div>';
    var iconPath = site.theme_uri + '/assets/icons/icons.svg#sprite-';
    $('.fancy-field').each(function () {
        var $this = $(this);
        var $label = $this.find('> label');
        var $inputContainer = $this.find('.ginput_container');
        var $recaptcha = $this.find('.ginput_recaptcha');
        var $inputWrapper = $this.find('input').parent();
        $inputWrapper.each(function () {
            var $thisWrapper = $(this);
            switch (true) {
                case  $thisWrapper.hasClass('ginput_container_email'):
                    $thisWrapper.append(Mustache.render(iconSvgWrapper, {hash: iconPath + 'Email'})).addClass('has-icon');
                    break;
                case  $thisWrapper.hasClass('ginput_container_phone'):
                    $thisWrapper.append(Mustache.render(iconSvgWrapper, {hash: iconPath + 'Phone'})).addClass('has-icon');
                    break;
                case $thisWrapper.hasClass('name_first'):
                    $thisWrapper.append(Mustache.render(iconSvgWrapper, {hash: iconPath + 'User'})).addClass('has-icon');
                    $thisWrapper.append($thisWrapper.find('label'));
                    break;
            }
        });

        if (!$recaptcha.length) {

            if (!$inputContainer.hasClass('ginput_container_radio') && !$inputContainer.hasClass('ginput_container_checkbox')) {
                $inputContainer.append($label);
                if ($inputContainer.hasClass('ginput_container_textarea')) {
                    $inputContainer.prepend($label);
                }
            } else {
                $this.addClass('fancy-check');
                return;
            }
            $this.find('.instruction.validation_message').addClass('sr-only');
            $('input, textarea').each(function () {
                var $thisInput = $(this);
                if ($thisInput.val()) {
                    $thisInput.addClass('filled');
                }
            });
            $this.addClass('fancy');
            $('input, textarea').blur(function () {
                var $thisInput = $(this);
                if (!$thisInput.val() || $thisInput.val() == '(___) ___-____') {
                    $thisInput.removeClass('filled');
                }
                else {
                    var value = $thisInput.val();
                    $thisInput.addClass('filled');
                    setTimeout(function () {
                        if (!$thisInput.val()) {
                            $thisInput.removeClass('filled');
                        }
                    }, 100);
                }
            });
        }
    });

    /* ------------------------------ /
     * Miscellaneous Setup
     * ------------------------------ */
    $('.hero-wrapper__carousel').owlCarousel({
        items: 1,
        dots: false,
        dotsContainer: '.hero-wrapper__dots',
        autoplay: true,
        animateOut: 'fadeOut',
        loop: true,
        rewind: true,
        touchDrag: false,
        mouseDrag: false
    });

    $('.widget-testimonials__carousel').owlCarousel({
        items: 1,
        autoplay: true,
        autoplayTimeout: 8000,
        loop: true,
        rewind: true,
        dots: true
    });

    $categoryToggler = $('.widget_categories.JS-TOGGLE .cat-toggler');
    $('.widget_categories.JS-TOGGLE .cat-toggler.active').next('.cat-links').slideDown();
    $categoryToggler.click(function () {
        var $this = $(this);

        if (!$this.hasClass('active')) {
            $categoryToggler.removeClass('active');
            $('.widget_categories .cat-links').slideUp();

            $this.next('.cat-links').slideDown(function () {
                $this.addClass('active');
            });
        }
    });

    $categoryToggler.find('a').click(function (e) {
        e.stopPropagation();
    });

    $('.map-contact__title').click(function () {
        var $this = $(this);
        $('.map-contact__content').slideUp();
        $(this).next('.map-contact__content').slideDown();
    });

    $('#regions > g').click(function () {
        var $this = $(this);
        var id = $this.attr('id');
        $('.map-contact:not([data-toggle=' + id + ']) .map-contact__content').slideUp();
        $('.map-contact[data-toggle=' + id + '] .map-contact__content').slideToggle();
    });

    $('#other_counties').click(function () {
        $('.map-contact:not([data-toggle=other]) .map-contact__content').slideUp();
        $('.map-contact[data-toggle=other] .map-contact__content').slideToggle();
    });
})(jQuery);
